import { RbacRoleObjectKey } from '../../../model';
import { IAPIServiceConfigItem } from '../../../model/api-modules';
import { store } from '../../../store';

export const findService = (
  serviceId: number,
  allServiceConfig: ReadonlyArray<IAPIServiceConfigItem>
) => {
  return allServiceConfig.find((v) => v.id === serviceId);
};

export const sortServiceConfig = (
  serviceConfig: ReadonlyArray<IAPIServiceConfigItem>
) => {
  const parentSort = serviceConfig
    .slice()
    .sort((a: IAPIServiceConfigItem, b: IAPIServiceConfigItem) => {
      if (a.ParentSort < b.ParentSort) {
        return -1;
      }
      if (a.ParentSort > b.ParentSort) {
        return 1;
      }

      if (a.ParentSort === b.ParentSort) {
        return +a.Sort - +b.Sort;
      }

      return 0;
    });
  return parentSort;
};

export const getServiceTopCategory = (
  services: ReadonlyArray<IAPIServiceConfigItem>
) => {
  const categoryName: string[] = [];
  sortServiceConfig(services).forEach((item) => {
    if (categoryName.indexOf(item.ParentName) === -1) {
      categoryName.push(item.ParentName);
    }
  });
  return categoryName;
};

export const checkIsEditor = (
  checkConf: {
    serviceName: string;
    envID?: string;
  },
  perms?: RbacRoleObjectKey[]
) => {
  let storePerms = perms;

  if (!storePerms) {
    const { envPerm } = store.getState().permission;
    storePerms = [...(envPerm[checkConf.envID || ''] || [])];
  }
  if (!storePerms) {
    return false;
  }
  const filterPerms = storePerms.filter(
    (item) =>
      ![RbacRoleObjectKey.FeeCenterEdit].includes(item as RbacRoleObjectKey)
  );
  let serviceName = checkConf.serviceName.replace(/\W/g, '');
  if (serviceName.trim() === 'Statistics') {
    serviceName = 'Stats';
  }

  if (serviceName.trim() === 'Battle') {
    return filterPerms.some((perm) =>
      [
        'BattlePartyEdit',
        'BattleLobbyEdit',
        // 'BattleMatchmakingEdit',
        'BattleCustomTagEdit',
      ].includes(perm)
    );
  }

  if (
    [
      'HealthMonitor',
      'Telemetry',
      'textChat',
      'voiceChat',
      'store',
      'gameItems',
      'remoteConfig',
      'DynamicUpdate',
      'LaunchUpdate',
    ].some(
      (nameItem) =>
        serviceName.toLowerCase().trim().replace(/\s/g, '') ===
        nameItem.toLowerCase()
    )
  ) {
    const checkReg = new RegExp('[a-z]+Edit$', 'i');
    return filterPerms.some((perm) => checkReg.test(perm));
  }
  const checkReg = new RegExp(`${serviceName}[a-z]*Edit$`, 'i');
  return filterPerms.some((perm) => checkReg.test(perm));
};
